<template>
  <HKLSelect
    v-model="proxyValue"
    mode="multiple"
    :defaultValue="defaultValue"
    :options="proxyOptions"
    :maxVisibleOptions="maxVisibleOptions"
    :respectOptionDisabled="respectOptionDisabled"
    v-bind="$attrs"
    v-on="$listeners"
  />
</template>
<script>
import i18n from '../../utils/i18n'
import HKLSelect, { SOURCE, EVENT } from './HKLSelect.vue'
import { ALL_VALUE, MAX_VISIBLE_DROPDOWN_OPTIONS } from './HKLMultiSelect.const'

export { SOURCE, EVENT } from './HKLSelect.vue'
export { ALL_VALUE } from './HKLMultiSelect.const'

/**
 * @type {import('vue').Component}
 */
export const HKLMultiSelect = {
  name: 'HKLMultiSelect',
  components: {
    HKLSelect,
  },
  model: {
    prop: SOURCE,
    event: EVENT,
  },
  props: {
    includeAll: {
      type: Boolean,
      default: false,
    },
    [SOURCE]: {
      type: Array,
      default: () => [],
    },
    defaultValue: {
      type: Array,
      default: () => [],
    },
    options: {
      type: Array,
      default: () => [],
    },
    maxVisibleOptions: {
      type: Number,
      default: MAX_VISIBLE_DROPDOWN_OPTIONS,
    },
    respectOptionDisabled: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    proxyValue: {
      get () {
        return this[SOURCE]
      },
      set (newValue) {
        this.$emit(EVENT, newValue)
      },
    },
    proxyOptions: {
      get () {
        const options = this.options
        if (!this.includeAll) return options
        const option = {
          name: i18n.t('component.ALL'),
          value: ALL_VALUE,
        }
        const group = {
          key: ALL_VALUE,
          name: i18n.t('component.ALL'),
          options: [option],
        }
        if (options.length === 0 || typeof options[0] === 'string' || !Array.isArray(options[0].options)) {
          return [option, ...options]
        } else {
          return [group, ...options]
        }
      },
    },
  },
}

export default HKLMultiSelect
</script>
